import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";
import { apiFunction } from "../utils";

/**
 * Pending Bootstrap admin API (storage roles).
 *
 * Cihazlar EMQX broker'a baglanmak icin /api/beverage-machine/bootstrap/request
 * anonim isteklerini server'a yapar. Manuel onay bekleyen kayitlar
 * burada listelenir; admin approve / reject aksiyonu yapar.
 *
 * Migration auto-approve kayitlari (Device kaydi mevcut ise) admin'e
 * dusmez — listede sadece manuel onay bekleyenler gorulur.
 */
export const pendingBootstrapApi = createApi({
  reducerPath: "pendingBootstrap",
  tagTypes: ["PendingBootstrap"],
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  keepUnusedDataFor: 60,
  endpoints(builder) {
    return {
      // Listele — status filtresi opsiyonel (default: pending_approval)
      getPendingBootstrapRequests: builder.query({
        query: ({ token, status }) => {
          const qs = new URLSearchParams();
          if (status) qs.append("status", status);
          const url = `/api/pending-bootstrap${qs.toString() ? `?${qs}` : ""}`;
          return {
            url,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          };
        },
        transformResponse: (response) => response?.data?.items || [],
        providesTags: (result) =>
          result
            ? [
                { type: "PendingBootstrap", id: "LIST" },
                ...result.map((item) => ({
                  type: "PendingBootstrap",
                  id: item._id,
                })),
              ]
            : [{ type: "PendingBootstrap", id: "LIST" }],
      }),

      // Onayla — cihaz /bootstrap/check'i tekrar cagirinca cred alir
      approveBootstrapRequest: builder.mutation({
        query: ({ token, id }) =>
          apiFunction(
            { token },
            `/api/pending-bootstrap/${id}/approve`,
            "POST"
          ),
        invalidatesTags: (_res, _err, arg) => [
          { type: "PendingBootstrap", id: "LIST" },
          { type: "PendingBootstrap", id: arg.id },
        ],
      }),

      // Reddet — sebep opsiyonel
      rejectBootstrapRequest: builder.mutation({
        query: ({ token, id, reason }) =>
          apiFunction(
            { token, reason },
            `/api/pending-bootstrap/${id}/reject`,
            "POST"
          ),
        invalidatesTags: (_res, _err, arg) => [
          { type: "PendingBootstrap", id: "LIST" },
          { type: "PendingBootstrap", id: arg.id },
        ],
      }),

      // "Şifreyi Goster" — credentials_issued bootstrap kaydinin son
      // rotate edilmis EMQX password'unu lazy-fetch ile getirir. Mutation
      // (cache'lenmesin diye) — her tıklamada server'dan taze deger alinir.
      revealBootstrapCredentials: builder.mutation({
        query: ({ token, id }) => ({
          url: `/api/pending-bootstrap/${id}/credentials`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
        transformResponse: (response) => response?.data || null,
      }),
    };
  },
});

export const {
  useGetPendingBootstrapRequestsQuery,
  useApproveBootstrapRequestMutation,
  useRejectBootstrapRequestMutation,
  useRevealBootstrapCredentialsMutation,
} = pendingBootstrapApi;
